import { fetchWithHeaders } from '@sendible/common';
import { MediaType } from '@sendible/shared-state-bridge';
import endpoints from '../../data-layer/endpoints';
import { getUrlWithCredentialsFromUser } from '../../utils';

export const useUpdateThumbnailById = ({ addToUploadingMedia, user, onError }: UseUploadThumbnailParams) => {
  const { method: mediaMethod, endpoint: mediaEndpoint } = endpoints.CreateMedia;

  return async ({ id, originalMediaId, fileId }: UpdateThumbnailByIdArgs) => {
    try {
      const mediaBody = {
        components: {
          poster: id,
        },
        sourceMediaId: originalMediaId,
      };

      const mediaResponse = (await fetchWithHeaders({
        method: mediaMethod,
        url: getUrlWithCredentialsFromUser(mediaEndpoint, user),
        body: mediaBody,
        params: { dashboardId: user.userId },
      })) as { result: MediaType };
      const { result: media } = mediaResponse;

      addToUploadingMedia(fileId ? { ...media, fileId } : media);

      return media;
    } catch (error) {
      onError(error, { fileId });

      return null;
    }
  };
};
